<template>
		<div class="content wrap-page">
		<Header></Header>
			<div class="info daily-content crfff">
        <div class="back" @click="back" style="">
          <img width="70" src="../../static/images/back.png" />
          <span class="fs50 w-title ac">{{$t('Daily')}} {{$t('Challenge')}}</span>
        </div>
        <div class="daily-top mt20 ac">
          <img src="../../static/images/daily-img1.png">
          <div class="daily-cate mt20 btn-purple por" @click="getDailyCate(user_category)"><span>{{$t('Category')}} : {{user_category.category_name}} ></span></div>
          <div class="btn btn-border" style="margin-top: -5px;padding-top: 10px;width: 60%;">{{$t('Chances')}} : {{dailyInfo.challenge_num}}</div>
        </div>
        <div class="fs50 w-title ac mt30">{{$t('PickLevel')}}</div>
        <div class="daily-list mt30">
          <div class="li disflex" :class="'li'+index" v-for="(item,index) in redeemList" @click="goBattleRoom('daily',item)">
            <div class="daily-font" :class="'lf'+index">
              <div class="">{{$t('EntryFee')}}<img class="ml10" src="../../static/images/point-2.png" />{{item.need_points}}</div>
              <div class="fs50">{{item.name}}</div>
            </div>
            <div class="li-t disflex">
              <div class="rf">
                <div class="disflex">
                  <div class="">
                    <img src="../../static/images/spin.png" />
                    <span style="vertical-align: bottom;" class="">{{$t('Rewards')}}</span>
                    <div class="disflex fs40" style="justify-content: right;">{{item.reward_rang}}<span class="ml10">{{$t('Spins')}}</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
       isShow:null,
       info:{},
       redeemInfo:{},
        redeemList:[],
        user_category:{},
        dailyInfo:{}
      }
    },
	created(){
    this.getRedeem()
	},
  methods: {
		back(){
      this.$router.push({path:'/'});
		},
    goBattleRoom(url,item){
      if(!item.can_play.status){
        this.$utils.alertText(item.can_play.tip);
        return;
      }
      this.$router.push({path:'/'+url,query: {id:item.id}});
    },
    getDailyCate(item){
      this.$router.push({path:'/selectChallenge',query: {}});
    },
    getRedeem(){
      let that = this
      that.$parent.loadModal(true);
      let data = {
        "question_type_id":1
      }
      that.$api.post('/api/daily_challenge/list',null,r =>{
        that.redeemList = r.data.list
        that.dailyInfo = r.data
        that.user_category = r.data.user_category
        that.$parent.loadModal(false);
      })
    },
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/DailyChallenge.vue